@if (platform$ | async; as platform) {
  <app-block [platform]="platform">
    @if (postData || photoReportData) {
      <div>
        @if (postData?.pinned && dataType !== DataTypesList.photoReport) {
          <app-information-label
            class="pinned-post"
            text="Запись закреплена"
          ></app-information-label>
        }
        @if (userViewType === PostUserViewType.full) {
          <app-post-header
            [date]="currentPostData?.created"
            [avatar]="currentPostData?.author?.avatar?.previewNormal"
            [fullName]="currentPostData?.author | getFullName"
            [position]="currentPostData?.author?.userPosition?.name"
            [department]="currentPostData?.author?.userDepartment?.name"
            [city]="currentPostData?.author?.userDepartment?.city?.name"
            [id]="currentPostData?.author?.id"
            [dateEmployment]="
              currentPostData?.author?.dateEmployment ?? currentPostData?.author?.date
            "
          >
            <div class="post-dropdown">
              <ng-container *ngTemplateOutlet="postDropdown"></ng-container>
            </div>
          </app-post-header>
        }
        @if (userViewType === PostUserViewType.mini) {
          <div class="post-dropdown post-user-block">
            <app-user-data
              [imgSize]="
                platform === CurrentPlatform.desktop
                  ? UserDataImgSize.m
                  : 'calc(' + UserDataImgSize.m + '*' + zoomValue
              "
              [date]="currentPostData?.created"
              [imgSrc]="currentPostData?.author?.avatar?.previewNormal"
              [fullName]="currentPostData?.author | getFullName"
              [position]="currentPostData?.author?.userPosition?.name"
              [id]="currentPostData?.author?.id"
              [dateEmployment]="
                currentPostData?.author?.dateEmployment ?? currentPostData?.author?.date
              "
            >
            </app-user-data>
            <ng-container *ngTemplateOutlet="postDropdown"></ng-container>
          </div>
        }
        @if (
          dataType === DataTypesList.photoReport ? photoReportData?.description : postData?.msg;
          as message
        ) {
          <div
            class="post-text"
            [class.block-mobile]="platform !== CurrentPlatform.desktop"
            [class.block-web]="platform === CurrentPlatform.desktop"
          >
            <app-post-text [postText]="message"></app-post-text>
          </div>
        }
        @if (
          dataType !== DataTypesList.photoReport &&
          postData &&
          postData.images &&
          postData.images.length
        ) {
          <div class="post-images">
            @if (postData.images.length === 1) {
              <div class="post-images__single">
                <img [src]="postData.images[0].path | addBaseUrl" (click)="openGalleryModal(0)" />
              </div>
            }
            <app-post-images-grid
              [images]="postData.images"
              (clicked)="openGalleryModal($event)"
            ></app-post-images-grid>
          </div>
        }
        @if (
          dataType !== DataTypesList.photoReport &&
          postData &&
          postData.files?.[0] &&
          !postData.files![0].mimeType.includes('image')
        ) {
          <div class="file-preview">
            <!-- Используем конструкцию postData.files!, так как выше проверили, что postData.files != null -->
            <app-file-upload
              [itemId]="postData.files![0].id"
              [fileTitle]="postData.files![0].name"
              [filePath]="postData.files![0].path"
              [inFavouritesList]="postData.files![0].favorite"
              [isDisabled]="(isLoadingFavorite$ | async) === true"
              (changeFavouritesStatus)="
                handleChangeFavouritesStatus(postData.files![0].id, postData.files![0].favorite)
              "
              [postFileView]="true"
              [currentPlatform]="platform"
              type="file"
            ></app-file-upload>
          </div>
        }
        @if (dataType !== DataTypesList.photoReport && postData && postData.poll) {
          <div class="post-poll">
            <app-polls
              [postData]="postData"
              [isStoreList]="isStoreList"
              [viewType]="viewType"
            ></app-polls>
          </div>
        }
        <div
          [class.block-mobile]="platform === CurrentPlatform.desktop"
          [class.block-web]="platform !== CurrentPlatform.desktop"
        >
          <app-post-information
            [isStoreList]="isStoreList"
            [postId]="currentPostData?.id"
            [postCommentsCount]="currentPostData?.commentCount"
            [postIsLiked]="currentPostData?.liked"
            [postLikesCount]="currentPostData?.likes"
            [viewType]="viewType"
            [dataType]="dataType"
            [onCommentIconClick]="onCommentIconClick"
          ></app-post-information>
        </div>
        <ng-content></ng-content>
        <ng-content select="[photoReport]"></ng-content>
      </div>
    }
    <ng-template #postDropdown>
      @if (currentUser$ | async; as currentUser) {
        @if (platform !== CurrentPlatform.desktop) {
          @if (getIsShowEditPhotoReportBtn(currentUser)) {
            <div class="button-mob">
              <img
                src="assets/images/icons-svg/edit.svg"
                alt="edit"
                (click)="editPhotoReport()"
                width="24"
                height="24"
              />
            </div>
          }
          @if (getIsShowDeletePhotoReportBtn(currentUser)) {
            <div class="button-mob">
              <img
                src="assets/images/icons-svg/delete-basket.svg"
                alt="delete"
                (click)="getAlertDeleteModal(deletePhotoReport, dataType === DataTypesList.post)"
                width="24"
                height="24"
              />
            </div>
          }
          @if (getIsShowDropdownButton(currentUser)) {
            <button
              [id]="
                viewType === ViewTypesList.modal
                  ? currentPostData?.id + '-modal'
                  : currentPostData?.id
              "
              class="post-dropdown__button"
              (click)="handleOpenMenu()"
            >
              <img
                [style.width]="MenuIconWidth.web"
                src="assets/images/icons-svg/posts/post-menu.svg"
                alt="menu"
              />
            </button>
          }
          <ion-popover
            cssClass="popover"
            [trigger]="
              viewType === ViewTypesList.modal
                ? currentPostData?.id + '-modal'
                : currentPostData?.id
            "
            [isOpen]="isOpen"
            (didDismiss)="isOpen = false"
            [dismissOnSelect]="true"
            side="bottom"
            alignment="start"
            [showBackdrop]="false"
          >
            <ng-template>
              <ion-content [forceOverscroll]="false">
                <app-dropdown-menu
                  [isPinned]="postData?.pinned"
                  [isOpen]="isOpen"
                  [postUserId]="photoReportData ? photoReportData.author?.id : postData?.author?.id"
                  [postId]="postData?.id"
                  [shopId]="photoReportData?.shop?.id"
                  [dataType]="dataType"
                  [viewType]="viewType"
                  (closeModalEvent)="handleOpenMenu()"
                  [getAlertDeleteModal]="getAlertDeleteModal"
                ></app-dropdown-menu>
              </ion-content>
            </ng-template>
          </ion-popover>
        }
        @if (platform === CurrentPlatform.desktop) {
          @if (getIsShowEditPhotoReportBtn(currentUser)) {
            <div class="post-dropdown__button">
              <img
                [style.width]="MenuIconWidth.web"
                src="assets/images/icons-svg/edit.svg"
                alt="edit"
                (click)="editPhotoReport()"
              />
            </div>
          }
          @if (getIsShowDeletePhotoReportBtn(currentUser)) {
            <div class="post-dropdown__button">
              <img
                [style.width]="MenuIconWidth.web"
                src="assets/images/icons-svg/delete-basket.svg"
                alt="delete"
                (click)="getAlertDeleteModal(deletePhotoReport, dataType === DataTypesList.post)"
              />
            </div>
          }
          @if (getIsShowDropdownButton(currentUser)) {
            <app-dropdown-container (emitDropdownClose)="isOpen = false">
              <button
                [id]="currentPostData?.id"
                class="post-dropdown__button"
                (click)="handleOpenMenu()"
              >
                <img
                  [style.width]="MenuIconWidth.web"
                  src="assets/images/icons-svg/posts/post-menu.svg"
                  alt="menu"
                />
              </button>
              @if (isOpen) {
                <app-dropdown-menu
                  [isPinned]="postData?.pinned"
                  [isOpen]="isOpen"
                  [postUserId]="photoReportData ? photoReportData.author?.id : postData?.author?.id"
                  [postId]="postData?.id"
                  [shopId]="photoReportData?.shop?.id"
                  [dataType]="dataType"
                  [viewType]="viewType"
                  (closeModalEvent)="handleOpenMenu()"
                  [getAlertDeleteModal]="getAlertDeleteModal"
                ></app-dropdown-menu>
              }
            </app-dropdown-container>
          }
        }
      }
    </ng-template>
  </app-block>
}
